import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, LocaleProvider } from "antd";
import { IntlProvider } from "react-intl";
import { Debounce } from "react-throttle";
import WindowResizeListener from "react-window-size-listener";
import { ThemeProvider } from "styled-components";
import authAction from "../../redux/auth/actions";
import appActions from "../../redux/app/actions";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import AppRouter from "./AppRouter";
import { AppLocale } from "../../dashApp";
import themes from "../../settings/themes";
import AppHolder from "./AppStyle";
import { toast, ToastContainer } from "react-toastify";
import fa_IR from "antd/lib/locale-provider/fa_IR";
import { toastConfig } from "settings";
import moment from "moment";
import { universalinit } from "../LanguageSwitcher/config";
import { setConfig } from "helpers/utility";
import "react-toastify/dist/ReactToastify.css";
import "moment/locale/fa";
import "assets/styles/global.css";
const { Content, Footer } = Layout;
const { logout, setRole } = authAction;
const { toggleAll } = appActions;

toast.configure(toastConfig);
moment.locale("fa");

export class App extends Component {
  componentDidMount() {
    this.props.setRole();
  }
  render() {
    const { url } = this.props.match;
    const { locale, selectedTheme, height } = this.props;
    const currentAppLocale = AppLocale[locale];
    const appHeight = window.innerHeight;
    universalinit(locale, AppLocale);
    setConfig(window.config);
    require("dotenv").config();

    return (
      <LocaleProvider locale={fa_IR}>
        {/* <LocaleProvider locale={currentAppLocale.antd}> */}
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <ThemeProvider theme={themes[selectedTheme]}>
            <AppHolder>
              <Layout style={{ height: appHeight }}>
                <Debounce time="1000" handler="onResize">
                  <WindowResizeListener
                    onResize={(windowSize) =>
                      this.props.toggleAll(
                        windowSize.windowWidth,
                        windowSize.windowHeight
                      )
                    }
                  />
                </Debounce>
                <Topbar url={url} />
                <Layout style={{ flexDirection: "row", overflowX: "hidden" }}>
                  <Sidebar url={url} />
                  <Layout
                    className="isoContentMainLayout"
                    style={{
                      height: height,
                    }}
                  >
                    <ToastContainer />
                    <Content
                      className="isomorphicContent"
                      style={{
                        padding: "70px 0 0",
                        flexShrink: "0",
                        background: "#f1f3f6",
                        position: "relative",
                      }}
                    >
                      <AppRouter url={url} role={this.props.auth.role} />
                    </Content>
                    <Footer
                      style={{
                        background: "#ffffff",
                        textAlign: "center",
                        borderTop: "1px solid #ededed",
                      }}
                    >
                      {window.config.FOOTER_TEXT}
                    </Footer>
                  </Layout>
                </Layout>
              </Layout>
            </AppHolder>
          </ThemeProvider>
        </IntlProvider>
      </LocaleProvider>
    );
  }
}

export default connect(
  (state) => ({
    auth: state.Auth,
    locale: "fa",
    selectedTheme: "themedefault",
    height: state.App.height,
  }),
  { setRole, logout, toggleAll }
)(App);
